import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

import { clearNotification } from '../../actions/notification.action'

import './Notification.scss'

const Notification = ({ notification, actions }) => {
  const onCloseClick = () => {
    actions.clearNotification()
  }

  useEffect(() => {
    if (!isEmpty(notification)) {
      setTimeout(() => {
        actions.clearNotification()
      }, 8000)
    }
  }, [notification])

  return (
    <>
      {!isEmpty(notification.message) && (
        <div
          className={`notification ${notification.class}`}
          role={String(notification.class || '').includes('danger') ? 'alert' : 'status'}
          aria-live={
            String(notification.class || '').includes('danger')
              ? 'assertive'
              : 'polite'
          }
        >
          <button
            onClick={onCloseClick}
            className="delete"
            aria-label="Close notification"
          />
          {notification.message}
        </div>
      )}
    </>
  )
}

Notification.propTypes = {
  notification: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    clearNotification: PropTypes.func
  }).isRequired
}

const mapStateToProps = state => {
  return {
    notification: get(state, 'notification', {})
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        clearNotification
      },
      dispatch
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Notification)
)
